import React from 'react';
import '../../Style/style.scss';

// import useTable from '../Footers/useTable';

const Helper = () => {
  // const { mailBox } =  useTable();
  return (
    <>
      <div className='content-helper'>
        <h4>
          Zobacz jak łatwo możesz dodać stopkę!
        </h4>
        <p><span role="img" aria-label="light bulb">💡</span>&nbsp;
        <a href="https://support.google.com/mail/answer/8395?hl=pl&co=GENIE.Platform%3DDesktop" target="_blank" rel="noreferrer">TUTAJ</a>
        &nbsp;znajdziesz informacje jak umieścić stopkę w Gmail.</p>
        <p><span role="img" aria-label="light bulb">💡</span>&nbsp;
        Jeśli używasz Thunderbird, kliknij <a href="https://support.mozilla.org/pl/kb/sygnatury" target="_blank" rel="noreferrer">TUTAJ.</a>
        </p>
        <p><span role="img" aria-label="light bulb">💡</span> Dla poczty Outlook, pomocny będzie&nbsp;
        <a href="https://support.microsoft.com/pl-pl/office/tworzenie-i-dodawanie-podpisu-do-wiadomo%C5%9Bci-8ee5d4f4-68fd-464a-a1c1-0e1c80bb27f2#ID0EBBF=Newer_versions" target="_blank" rel="noreferrer">TEN LINK.</a></p>
      </div>
      {/* {(mailBox === "thunderbird") ? (
        <div className='content-helper'>
          <h4>
          Zobacz jak łatwo możesz dodać stopkę dla Gmaila!
          </h4>
          <p><span role="img" aria-label="light bulb">💡</span>&nbsp;
          <a href="https://support.google.com/mail/answer/8395?hl=pl&co=GENIE.Platform%3DDesktop" target="_blank" rel="noreferrer">TUTAJ</a>
          &nbsp;znajdziesz szczegółowe informacje jak umieścić stopkę w Gmail.</p>
          <p><span role="img" aria-label="light bulb">📫</span>&nbsp;
          W skrócie, przejdź do: Gmail &gt; Ustawienia &gt; Wszystkie ustawienia &gt; Podpis</p>
          </div>
        ) : (
              <p>sdasd</p>
        )} */}
    </>
  )
};

export default Helper;
